import { Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { AlertSeverityEnum, Contrato, UrlAnexoNombreUrl } from '@/shared/interfaces';
import { getForwardDocuments, putPreventaById } from '@/shared/actions/erp';
import { putPreventaPymes } from '@/shared/actions/erp/preventa_pymes/preventa_pymes.action';

import copy from 'copy-to-clipboard';
import { saveAs } from 'file-saver';
import { useUiStore } from '@/store/ui';
import { CustomAutocompleteNoForm, LoaderComponent } from '@/shared/components/ui';
import { useState, useRef } from 'react';
import { SummarizeOutlined } from '@mui/icons-material';
import { getEnvs, gridSizeMdLg12 } from '@/shared';
import ButtonGenerarDocumentos from '@/shared/components/erp/GenerarDocumentos/ButtonGenerarDocumentos';
import { toast } from 'react-toastify';

const { VITE_API_URL_OFICINA_VIRTUAL } = getEnvs();

type IRow = {
  name: string | null
  url: string | null | any
  urlOficina?: string | null,
  key: string
  tipo: 'PYMES' | 'HOME' | 'GENERAL'
};

enum keyENUM {
  CONTRATO = 'CONTRATO',
  ANEXO_1F = 'ANEXO_1F',
  ANEXO_2F = 'ANEXO_2F',
  ANEXO_2PYMES = 'ANEXO_2PYMES',
  ANEXO_3_ORDEN = 'ANEXO_3_ORDEN',
  AUTORIZACION_BANCARIO = 'AUTORIZACION_BANCARIO',
  AUTORIZACION_TARJETA = 'AUTORIZACION_TARJETA',
  AUTORIZACION_BURO = 'AUTORIZACION_BURO',
  SOLICITUD_BENEFICIO = 'SOLICITUD_BENEFICIO'
}

export type ShowContractsAgendaModalProps = {
  ordenTrabajoId?: string
  contrato: Contrato
  razonSocial?: string
  tooltipMessage?: string

  showBtnPreview?: boolean
  showBtnDownload?: boolean
  showBtnCopy?: boolean
  contratoFisico?: boolean

  //para pyl
  showBtnGenDocs?: boolean
  showBtnForward?: boolean
  idPreventa?: string

  ///* Autorizacion
  showBtnGenAutorizacion?: boolean
  url_autorizacion_debito_automatico?: string | null
  url_autorizacion_cargo_tarjeta?: string | null
  formaPago?: string
  routerOficinaVirtual?: string

  tipoModal?: 'HOME' | 'PYMES'
  urlFirmaDigital?: string | null
};

// Solo es una solicitud de actualización - NO bloquea el flujo
const ShowContractsAgendaModal: React.FC<ShowContractsAgendaModalProps> = ({
  ordenTrabajoId,
  contrato,
  razonSocial = "Default",
  tooltipMessage = "Generar Documentos",
  showBtnGenDocs = false,
  showBtnPreview = true,
  showBtnDownload = true,
  showBtnCopy = true,
  showBtnForward = false,
  idPreventa,
  contratoFisico = false,
  //* Autorizacion
  showBtnGenAutorizacion = false,
  url_autorizacion_debito_automatico,
  url_autorizacion_cargo_tarjeta,
  formaPago,
  routerOficinaVirtual = 'ver-contrato/',
  tipoModal = 'HOME',
  urlFirmaDigital = null
}) => {
  //CONST
  const [openModalDocuments, setOpenModalDocuments] = useState<boolean>(false);
  const [dataDocsContrato, setDataDocsContrato] = useState<Contrato>(contrato)
  const [showBtnGenAutorizacionAux, setShowBtnGenAutorizacionAux] = useState(showBtnGenAutorizacion)
  const [documentosGeneradosAutomaticamente, setDocumentosGeneradosAutomaticamente] = useState(false)
  const [isGeneratingAutorizacion, setIsGeneratingAutorizacion] = useState(false)
  const [anexo2PymesSelected, setAnexo2PymesSelected] = useState<UrlAnexoNombreUrl | null>(null)
  const autoGeneracionEjecutadaRef = useRef(false)
  const isGlobalLoading = useUiStore.getState().isGlobalLoading

  function validateUrl(url: string | null | undefined) {
    const date = new Date().getTime();
    return url ? `${url}?v=${date}` : null
  }

  const [rows, setRows] = useState<IRow[]>(
    [
      {
        name: "Contrato",
        url: validateUrl(dataDocsContrato?.url_contrato),
        urlOficina: `${VITE_API_URL_OFICINA_VIRTUAL}${routerOficinaVirtual}${idPreventa}` || null,
        key: keyENUM.CONTRATO,
        tipo: 'GENERAL'
      },
      {
        name: "Anexo 1F",
        url: validateUrl(dataDocsContrato?.url_anexo_1_f),
        key: keyENUM.ANEXO_1F,
        tipo: 'HOME'
      },
      {
        name: "Anexo 2F",
        url: validateUrl(dataDocsContrato?.url_anexo_2_f),
        key: keyENUM.ANEXO_2F,
        tipo: 'HOME'
      },

      {
        name: "Anexo 1 Orden",
        url: validateUrl(dataDocsContrato?.url_anexo_1_orden),
        key: keyENUM.ANEXO_2F,
        tipo: 'PYMES'
      },
      {
        name: "Anexo 2",
        url: dataDocsContrato?.url_anexo_2_pymes as UrlAnexoNombreUrl[],
        key: keyENUM.ANEXO_2PYMES,
        tipo: 'PYMES'
      },
      // {
      //   name: "Anexo 3 Orden",
      //   url: validateUrl(dataDocsContrato?.url_anexo_3_f),
      //   key: keyENUM.ANEXO_2F,
      //   tipo: 'PYMES'
      // },
      {
        name: "Autorización debito bancario",
        url: validateUrl(url_autorizacion_debito_automatico),
        key: keyENUM.AUTORIZACION_BANCARIO,
        tipo: 'GENERAL'
      },
      {
        name: "Autorización cargo tarjeta",
        url: validateUrl(url_autorizacion_cargo_tarjeta),
        key: keyENUM.AUTORIZACION_TARJETA,
        tipo: 'GENERAL'
      },
      {
        name: "Autorización de Buró",
        url: validateUrl(dataDocsContrato?.url_autorizacion_buro),
        key: keyENUM.AUTORIZACION_BURO,
        tipo: 'GENERAL'
      },
      {
        name: "Solicitud de descuento",
        url: validateUrl(dataDocsContrato?.url_solicitud_beneficio),
        key: keyENUM.SOLICITUD_BENEFICIO,
        tipo: 'GENERAL'
      },
    ]
  )

  const setAlert = useUiStore(s => s.setAlert);

  const reenviarDocumentos = async () => {
    if (!idPreventa)
      return setAlert(true, "No existen datos de preventa", AlertSeverityEnum.info)

    const res = await getForwardDocuments(idPreventa)
    console.log({ reenvio: res })
    res?.code == 200 ?
      setAlert(true, "Documentos reenviados", AlertSeverityEnum.success)
      : setAlert(true, "No se pudieron enviar los documentos, intente mas tarde.", AlertSeverityEnum.error)
    // setDataDocsContrato(res.data.contrato_data!)
  }


  const handleDownload = async (urlDocument: string, nameDocument: string) => {
    try {
      const response = await fetch(urlDocument);
      const blob = await response.blob();
      saveAs(blob, nameDocument);
    } catch (error) {
      setAlert(
        true,
        "Hubo un problema al descargar el documento. Espere un momento y vuelva a generarlos.",
        AlertSeverityEnum.error)
      console.error('Error downloading the file', error);
    }
  };

  const copyToClipboard = async (copyText: string) => {
    if (!copyText)
      return setAlert(true, 'No hay enlace para copiar', AlertSeverityEnum.warning);

    const success = copy(copyText);
    if (success) {
      setAlert(true, '¡Copiado en portapapeles!', AlertSeverityEnum.success);
    } else {
      setAlert(true, 'Error al copiar el texto', AlertSeverityEnum.error);
    }

  };


  const generarDocAutorizaion = async () => {
    console.log('[generarDocAutorizaion] Iniciando generación...');
    console.log('[generarDocAutorizaion] formaPago:', formaPago);
    console.log('[generarDocAutorizaion] tipoModal:', tipoModal);
    console.log('[generarDocAutorizaion] idPreventa:', idPreventa);

    let dataAutorizacion: any = {}

    // Normalizar forma de pago para comparación (sin tildes y en mayúsculas)
    const formaPagoNormalizado = formaPago?.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    console.log('[generarDocAutorizaion] formaPagoNormalizado:', formaPagoNormalizado);

    if (formaPagoNormalizado === 'DEBITO')
      dataAutorizacion.generar_pdf_autorizacion_debito_automatico = true
    if (formaPagoNormalizado === 'TARJETA')
      dataAutorizacion.generar_pdf_autorizacion_cargo_tarjeta = true

    console.log('[generarDocAutorizaion] dataAutorizacion:', dataAutorizacion);

    setIsGeneratingAutorizacion(true)
    try {
      // Usar el endpoint correcto según el tipo de modal
      const resp = tipoModal === 'PYMES'
        ? await putPreventaPymes({ id: idPreventa!, data: dataAutorizacion })
        : await putPreventaById(idPreventa!, dataAutorizacion)

      console.log('[generarDocAutorizaion] Respuesta del servidor:', resp);
      console.log('[generarDocAutorizaion] resp.code:', resp.code);
      console.log('[generarDocAutorizaion] resp.data:', resp.data);

      if (resp.code == 200) {
        console.log('[generarDocAutorizaion] Código 200 - Actualizando URLs...');
        console.log('[generarDocAutorizaion] URL débito:', resp.data.url_autorizacion_debito_automatico);
        console.log('[generarDocAutorizaion] URL tarjeta:', resp.data.url_autorizacion_cargo_tarjeta);

        setShowBtnGenAutorizacionAux(false)
        setDocumentosGeneradosAutomaticamente(true)
        // Actualizar las filas existentes en lugar de agregar nuevas
        setRows(prevRows => {
          const newRows = prevRows.map(row => {
            if (row.key === keyENUM.AUTORIZACION_BANCARIO) {
              console.log('[generarDocAutorizaion] Actualizando fila DÉBITO');
              return { ...row, url: validateUrl(resp.data.url_autorizacion_debito_automatico) }
            }
            if (row.key === keyENUM.AUTORIZACION_TARJETA) {
              console.log('[generarDocAutorizaion] Actualizando fila TARJETA');
              return { ...row, url: validateUrl(resp.data.url_autorizacion_cargo_tarjeta) }
            }
            return row
          });
          console.log('[generarDocAutorizaion] Nuevas filas:', newRows);
          return newRows;
        })
      } else {
        console.log('[generarDocAutorizaion] Código NO es 200:', resp.code);
      }
    } catch (error) {
      console.error('[generarDocAutorizaion] Error generando autorización:', error)
      setAlert(true, 'Error al generar autorización', AlertSeverityEnum.error)
    } finally {
      setIsGeneratingAutorizacion(false)
    }
  }

  // Función para abrir el modal y generar autorización automáticamente si es necesario
  const handleOpenModal = async () => {
    console.log('[handleOpenModal] showBtnGenAutorizacionAux:', showBtnGenAutorizacionAux);
    console.log('[handleOpenModal] autoGeneracionEjecutadaRef.current:', autoGeneracionEjecutadaRef.current);
    console.log('[handleOpenModal] formaPago prop:', formaPago);

    if (showBtnGenAutorizacionAux && !autoGeneracionEjecutadaRef.current) {
      console.log('[handleOpenModal] Ejecutando generación automática...');
      autoGeneracionEjecutadaRef.current = true
      await generarDocAutorizaion()
    } else {
      console.log('[handleOpenModal] NO se ejecuta generación automática');
    }
    setOpenModalDocuments(true)
  }

  return (
    <>
      <Tooltip title={tooltipMessage}>
        <IconButton
          onClick={handleOpenModal}
          disabled={isGeneratingAutorizacion}
        >
          <SummarizeOutlined />
        </IconButton>
      </Tooltip>
      {openModalDocuments ?
        <ScrollableDialogProps
          open={openModalDocuments}
          onCloseIcon={() => setOpenModalDocuments(false)}
          title="Administración de Documentos"
          minWidth="40%"
          /*  onClose={() => {
             setOpenModalDocuments(false)
           }} */
          onConfirm={() => setOpenModalDocuments(false)}
          showConfirmBtn={false}
          //cancelTextBtn="Volver"
          confirmVariantBtn="outlined"
          contentNode={
            <Grid item container xs={12} mb={3} spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ marginY: "5px" }}>
                  Documentos del cliente {razonSocial || ""}
                </Typography>
                <Grid container item xs={12} sx={{ marginY: "10px" }}>
                  {
                    showBtnGenDocs ?
                      <Grid item xs={5}>
                        {/* <Button
                          onClick={() => {
                            console.log("Generando documentos...")
                            generarDocumentos(ordenTrabajoId!)
                          }}
                        >Generar documentos</Button> */}
                        <ButtonGenerarDocumentos
                          ordenTrabajoId={ordenTrabajoId!}
                          getResDataFunction={(res) => setDataDocsContrato(res.data.contrato_data!)}
                          signatureInDocs={true}
                        />
                      </Grid>
                      : null
                  }
                                    {
                    showBtnForward ? (
                      rows[0].url && rows[1].url && rows[2].url && (
                        <Grid item xs={7}>
                          <Button
                            onClick={() => {
                              console.log("Reenviando documentos...")
                              reenviarDocumentos()
                            }}
                          >Reenviar documentos al cliente</Button>
                        </Grid>
                      )
                    ) : null
                  }
                </Grid>
                <TableContainer component={Paper} sx={{ minHeight: "250px" }}>
                  {
                    isGlobalLoading || isGeneratingAutorizacion ?
                      (<LoaderComponent />)
                      : (
                        <Table sx={{ minWidth: 450 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: "20%" }}>Tipo de Documento</TableCell>
                              {showBtnCopy ? <TableCell align="right" sx={{ width: "25%" }}>Enlace</TableCell> : null}
                              {/* {showBtnForward ? <TableCell align="right" sx={{ width: "25%" }}>Reenviar</TableCell> : null} */}
                              {showBtnPreview ? <TableCell align="right" sx={{ width: "25%" }}>Ver</TableCell> : null}
                              {showBtnDownload ? <TableCell align="right" sx={{ width: "25%" }}>Descargar</TableCell> : null}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {/* {rows.filter(e => e.url != null).map((row) => ( */}
                            {rows.filter(e => e.tipo == 'GENERAL' || e.tipo == tipoModal).map((row) => {
                              console.log(row)
                              // return row?.url ?
                                return row.name == "Anexo 2" && row.tipo == "PYMES" && !row.url ?
                                null 
                                :row.name == "Anexo 2" && row.tipo == "PYMES" && row.url ? 
                                <TableRow
                                  key={`${row.name}-${row.tipo}`}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.name}
                                  </TableCell>

                                  {showBtnCopy ?
                                    <TableCell align="right" width={"100%"}>
                                      <Grid {...gridSizeMdLg12} container spacing={2}>
                                        <CustomAutocompleteNoForm
                                          label="Seleccione un enlace"
                                          //name="label"
                                          options={row?.url || [] }
                                          valueKey={'nombre'}
                                          actualValueKey={'url'}
                                          defaultValue={''}
                                          isLoadingData={false}
                                          onChangeRawValue={(value) => {
                                            console.log(value)
                                            setAnexo2PymesSelected(value)
                                            copyToClipboard(value?.url)
                                          }}
                                          size={gridSizeMdLg12}
                                        />
                                      </Grid>
                                    </TableCell>
                                    : null}


                                  {showBtnPreview ?
                                    <TableCell align="right">
                                      <Tooltip title="Vista Previa"
                                      >
                                        <a href={anexo2PymesSelected?.url ?? undefined} target="_blank" rel="noopener noreferrer">
                                          <IconButton
                                            disabled={!anexo2PymesSelected?.url}
                                          >
                                            <VisibilityIcon />
                                          </IconButton>
                                        </a>
                                      </Tooltip>
                                    </TableCell>
                                    : null}

                                  {showBtnDownload ?
                                    <TableCell align="right">
                                      <Tooltip title="Descargar">
                                        <IconButton onClick={async () => {
                                          if (!anexo2PymesSelected?.url) {
                                            toast.info('Documento no encontrado. [404]')
                                            return;
                                          }

                                          await handleDownload(anexo2PymesSelected?.url!, `${anexo2PymesSelected?.nombre} - ${razonSocial}.pdf`)
                                        }} disabled={!anexo2PymesSelected?.url}>
                                          <DownloadIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                    : null}

                                </TableRow>
                                :
                                //cualquiera que no sea anexo 2 de pymes
                                <TableRow
                                  key={row.name}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.name}
                                  </TableCell>

                                  {showBtnCopy ?
                                    <TableCell align="right">
                                        <Tooltip title="Copiar Enlace">
                                        <IconButton disabled={!row?.url} onClick={() => {

                                          ///* TODO: validar cuando el contrato es para oficina virtual, adicional
                                          /// el contrato solo se puede copiar una vez para preagendamiento en venta

                                          if (!row.url) {
                                            toast.info('Documento no encontrado. [404]')
                                            return;
                                          }

                                          if (contratoFisico && (row.key != keyENUM.AUTORIZACION_BANCARIO && row.key != keyENUM.AUTORIZACION_TARJETA)) {
                                            return setAlert(true, 'Se ha solicitado un contrato en formato físico.', AlertSeverityEnum.info)
                                          }

                                          // Si hay firma digital activa, copiar el link de firma para todos los documentos
                                          if (urlFirmaDigital)
                                            return copyToClipboard(urlFirmaDigital);

                                          if (row.name === 'Contrato')
                                            return copyToClipboard(row.urlOficina!);

                                          copyToClipboard(row.url!);
                                        }}>
                                          <ContentCopyIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                    : null}

                                  {showBtnPreview ?
                                    <TableCell align="right">
                                      <Tooltip title="Vista Previa"
                                      >
                                        <a href={row.url ?? undefined} target="_blank" rel="noopener noreferrer"
                                          onClick={(e) => {
                                            if (!row.url) e.preventDefault();
                                          }}>
                                          <IconButton
                                            disabled={!row.url}
                                          >
                                            <VisibilityIcon />
                                          </IconButton>
                                        </a>
                                      </Tooltip>
                                    </TableCell>
                                    : null}

                                  {showBtnDownload ?
                                    <TableCell align="right">
                                      <Tooltip title="Descargar">
                                        <IconButton onClick={async () => {
                                          if (!row.url) {
                                            toast.info('Documento no encontrado. [404]')
                                            return;
                                          }

                                          await handleDownload(row.url!, `${row.name} - ${razonSocial}.pdf`)
                                        }} disabled={!row?.url}>
                                          <DownloadIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  : null}

                                </TableRow>
                              // :null
                            })}
                          </TableBody>
                        </Table>
                      )
                  }
                </TableContainer>
                {documentosGeneradosAutomaticamente && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: 'block',
                      mt: 1,
                      color: 'success.main',
                      fontStyle: 'italic',
                      textAlign: 'right'
                    }}
                  >
                    * Documentos generados automáticamente
                  </Typography>
                )}
              </Grid>

            </Grid>
          }
        /> : null}
    </>



  );
};

export default ShowContractsAgendaModal;
